import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { navigationActions } from './navigation.actions';

export const navigate$ = createEffect(
  (actions$ = inject(Actions), router = inject(Router)) =>
    actions$.pipe(
      ofType(navigationActions.go),
      map((action) => action),
      tap(({ path, query, extras, forceReload }) => {
        if (forceReload) {
          router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => router.navigate(path, { queryParams: query, ...extras }));
        } else {
          router.navigate(path, { queryParams: query, ...extras });
        }
      }),
    ),
  { functional: true, dispatch: false },
);
